import {RegressionAnalysis} from './RegressionTypes';

interface QuadraticModelFit {
  B0: number;
  B1: number;
  B2: number;
}

export type QuadraticRegressionResults = QuadraticModelFit & {
  R2: number;
};

export type QuadraticRegressionAnalysis = RegressionAnalysis<QuadraticRegressionResults>;

export function estimatePointY(
  pointX: number,
  modelFit: Pick<QuadraticModelFit, 'B2' | 'B1' | 'B0'>
): number {
  return modelFit.B2 * Math.pow(pointX, 2) + modelFit.B1 * pointX + modelFit.B0;
}
